
export default {
	home: 'Home',
	hosintro: 'Hospital Intro',
	departmentnav: 'Department Navigation',
	expertintro: 'Expert Intro',
	hosdynamic: 'Hospital Dynamic',
	appointment: 'Appointment',
	joinus: 'Join Us',
	routenav: 'Route Navigation',
	notice: 'Notice',
	news: 'News',
	media: 'Media',
	opentender: 'Open Tender',
	more: 'More',
	msg: 'Message',
	ms: 'Info',
	honor: 'Honor',
	Process: 'Process',
	job: 'Recruitment',
	tomail: 'If you are interested, please send your resume to the mailbox',
	friendlink: 'FriendLink',
	address: 'Address',
	tel: 'Tel',
	jobdetail: 'Position Detail',
	position: 'Position',
	personnum: 'Number Of People',
	edu: 'Education',
	place: 'Workplace',
	salary: 'Salary',
	requirements: 'Requirements',
	workexperience: 'Work Experience',
	expert: 'Experts',
	k: '',
	xzzzqdermyy: "The second people's hospital of Tibet autonomous region",
	qdndjr: 'Looking forward to your joining',
	contactus: 'Contact Us',
	mail: 'Mail',
	department: 'Department',
	professionaltitle: 'Professional Title',
	famous: 'Famous',
	detailintro: 'Detail',
	gethonor: 'Honor'
}


// WEBPACK FOOTER //
// ./src/utils/en-US.js